<template>
    <Modal title="Periodical Evaluation Report( when finishing 20/80/160 classes)" v-model="showModal" width="750">
      <div class="evaluate">
        <el-alert
            :closable="false"
            :title="title"
            type="info"
            description="Remember that learning is a continuous process, With your dedication and hard work, you can continue to grow and excel in your language learning journey. Keep up the good work!">
        </el-alert> 
      </div>
      <div class="evaluate">
          <h3>Part one：Student's overal performance in English learning (must include the student's progress in listening, speaking, reading, writing/grammar/vocabulary building，no less than 80 words in total)</h3>
          <el-input
            type="textarea"
            :rows="5"
            placeholder="Enter something..."
            v-model="formData.remark">
          </el-input>
      </div>
        <div class="evaluate">
          <h3>Part two： Learning Suggestions</h3>
          <p class="title">You can list learning suggestions, learning websites etc, and encourage the student to continue English courses.</p>
          <el-input
            type="textarea"
            :rows="3"
            placeholder="Enter something..."
            v-model="formData.suggestions">
          </el-input>
          <MultiUpload class="title" @on-file-change="changeFile" :num="1" :defaultFileList="this.formData.fileList"/>
        </div>
      <div slot="footer">
        <Button type="text" size="large" @click="onClose">Cancel</Button>
        <Button v-if="!readonly" type="primary" size="large" :loading="loading" @click="onSubmit">Submit</Button>
      </div>
    </Modal>
</template>
<script>
    export default {
      name: 'StudentWriteReviewFinishLevel',
      props: {
        formData: {
          type: Object,
          default: {
            return: {}
          }
        },
        value: {
          type: Boolean,
          default: {
            return: false
          }
        },
        openedId: {
          type: Number
        },
        reviewState: {
          type: Number
        },
        readonly: {
          type: Boolean,
          default: false
        },
      },
      data () {
        return {
          title: '',
          uid: '',
          openid: '',
          state: '',
          form: {
            rating: 4 
          },
          rateValue: 0,
          v1: 4,
          v2: 2,
          showModal: this.value,
          loading: false,
          StudentWriteReiviewFormData: {
            lessonId: null,
            tchId: null,
            status: 0,
            remark: ''
          },
          lessonErrRule: {
            remark: [
              { type: 'string', required: true, message: ' ', trigger: 'blur' }
            ],
          },
        }
      },
      methods: {
        changeFile (fileList) {
          this.formData.fileList = fileList
        },
        handleChange (value) {
          if (value < 2) {
            this.rateValue = 2 
          }
        },
        starChange (v) {
          console.log(this.v2)  
          console.log(this.v2)
        },
        onClose () {
          this.StudentWriteReiviewFormData = {}
          this.$emit('on-close')
        },
        hasNumWords (str, num) {
          const words = str.split(' ') // 将字符串按空格切割成单词数组
          return words.length >= num // 判断单词数量是否大于等于80
        },
        onload () {
          let self = this
          self.$http.get('/bookTchFeedback/queryByLsnOpenId?lsnOpenId=' + self.openid).then(res => {
            let {uid, stageComment, nickname, routineEndNum} = res.data
            this.title = `${nickname} congratulations on completing ${routineEndNum} English classes! You should be proud of yourself for making it through this course, with all of the hard work and dedication that you put in. English is a challenging language to learn, but you pushed through and made progress each day. Whether it was improving your grammar, expanding your vocabulary, or practicing your speaking and listening skills, you've developed valuable language abilities that will serve you well in the future.`
            if (stageComment) {
              let {part1, part2} = JSON.parse(stageComment)
              this.formData.remark = part1
              this.formData.suggestions = part2.text
              if (part2.file !== '') {
                this.formData.fileList = [{url: part2.file}]
              }else {
                this.formData.fileList = []
              }
              
            } else {
              this.formData.remark = ''
              this.formData.suggestions = ''
              this.formData.fileList = []
            }
            self.uid = uid 
          })
        },
        onSubmit () {
          let self = this
          let part1 = this.formData.remark
          if (!self.hasNumWords(part1, 80)) {
            self.$Message.error('Part 1 requires at least 80 words to be entered')
            return 
          }
          let part2 = {
            text: this.formData.suggestions,
            file: this.formData.fileList.length > 0 ? this.formData.fileList[0].url : ''
          }
          let data = {
            part1: part1,
            part2: part2
          }
          let parmas = {}
          parmas.stageComment = JSON.stringify(data)
          parmas.lsnOpenId = self.openid
          // parmas.reviewState = self.state
          parmas.uid = self.uid
          parmas.version = 1 
          parmas.stageSummary = true 
          this.$http.post('/bookTchFeedback/update', parmas).then(function (res) {
            self.$Message.success('success')
            self.showModal = false
          }).catch(function (e) {
            // this.loadingUpdate = false
          })
          console.log(data)
        },
      },
      watch: {
        reviewState (val) {
          this.state = val
        },
        openedId (val) {
          this.openid = val
        },
        value (val) {
          this.showModal = val
          if (val === true) {
              // this.scoreCompute()
            this.onload()
          } else {
            // this.feedback = {}
            // this.visible = val
          }
        },
        showModal (val) {
          if (val === false) {
            this.$emit('on-close')
          }
        },
        formData (val) {
          if (val) {
            this.lessonErrFormData = val
          }
        },
      }
    }
</script>
<style>
.title {
  font-size: 10px;
}
</style>



// WEBPACK FOOTER //
// StudentWriteReviewFinishLevelModal.vue?4f6d786a